import axios from 'axios'
import { getApiBaseUrl, isDevelopment, logEnvInfo } from './env'
import { message } from 'ant-design-vue'
import router from '@/router'

// 打印环境信息（仅在开发环境）
logEnvInfo()
console.log('接口地址：', import.meta.env.VITE_API_BASE_URL)
// 基础 axios 实例
const service = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 15000,
  withCredentials: true
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 这里可按需注入 Token
    const token = localStorage.getItem('token')
    config.headers = config.headers || {}
    config.headers['Content-Type'] = 'application/json'
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 后端统一返回处理，可在此做错误码拦截
    console.log(response)
    const data = response.data

    if (response.config.customReturnAll) {
      return data
    }

    if(data.code === 10000) {
      message.error(data.message)
      router.push('/login')
      return Promise.reject(data.message)
    } else if(data.code !== 0){
      message.error(data.message)
      return Promise.reject(data.message)
    } else {
      return data.data || data
    }
  },
  (error) => {
    // 统一错误处理
    if (error.response) {
      // 可以根据 status 做不同处理
      // console.error('API Error:', error.response.status, error.response.data)
    } else if (error.request) {
      // console.error('Network Error: No response received')
    } else {
      // console.error('Request Error:', error.message)
    }
    return Promise.reject(error)
  }
)

// 便捷方法
export const httpGet = (url, params, config = {}) => service.get(url, { params, ...config })
export const httpPost = (url, data, config = {}) => service.post(url, data, config)
export const httpPut = (url, data, config = {}) => service.put(url, data, config)
export const httpDelete = (url, params, config = {}) => service.delete(url, { params, ...config })

export default service


